export default __webpack_public_path__ + "static/media/NotFoundRingRing.df6505fe.png";